// Each form row owns its lookup. A different row must keep its own check alive.
const requestsByDispatch = new WeakMap();
const requestKey = (values, kind) => JSON.stringify([
  kind,
  values?.availability_owner || String(values?.formName || '').split('/').slice(0, 3).join('/'),
  values?.availability_owner ? '' : (values?.id || values?.index_id || values?.uid || ''),
  values?.availability_owner ? '' : (values?.parent_id || ''),
]);

export const cancelChildAvailability = (values, dispatch, kind) => {
  const requests = requestsByDispatch.get(dispatch);
  const key = requestKey(values, kind);
  const entry = requests?.get(key);
  requests?.delete(key);
  entry?.pending.abort?.();
};

// Formik shifts the remaining indexes when a row is removed. Move ownership
// with those rows so the next edit cannot cancel a different row's lookup.
export const removeChildAvailabilityRow = (formType, field, index, dispatch) => {
  const requests = requestsByDispatch.get(dispatch);
  if (!requests) return;
  const kind = field === 'addonservices' ? 'addon' : 'addanother';
  const prefix = `${formType}/${field}/`;
  const moved = [];
  for (const [key, entry] of requests) {
    const parts = JSON.parse(key);
    if (parts[0] !== kind || !parts[1].startsWith(prefix)) continue;
    const row = Number(parts[1].slice(prefix.length));
    if (!Number.isInteger(row) || row < index) continue;
    requests.delete(key);
    if (row === index) {
      entry.pending.abort?.();
    } else {
      parts[1] = `${prefix}${row - 1}`;
      entry.key = JSON.stringify(parts);
      moved.push(entry);
    }
  }
  moved.forEach(entry => requests.set(entry.key, entry));
};

export const latestChildAvailability = (values, dispatch, actionCreator, onResult, kind) => {
  cancelChildAvailability(values, dispatch, kind);
  if (!requestsByDispatch.has(dispatch)) requestsByDispatch.set(dispatch, new Map());
  const requests = requestsByDispatch.get(dispatch);
  const key = requestKey(values, kind);
  const pending = dispatch(actionCreator({ ...values, roster_time: true }));
  const entry = { key, pending };
  requests.set(key, entry);
  return pending.then(action => {
    if (requests.get(entry.key) === entry && !action.meta?.aborted) onResult(action);
    return action;
  }).finally(() => {
    if (requests.get(entry.key) === entry) requests.delete(entry.key);
  });
};
